import { NgModule } from "@angular/core";
import { GedFormComponent } from './ged-form/ged-form.component';
import { DynamicGedComponent } from './dynamic-ged.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { GedDesignComponent } from './ged-design/ged-design.component';
import { GedResultComponent } from './ged-result/ged-result.component';
import { MaterialModule } from '../../material.module';
import { DocumentScannerModule } from '../document-scanner/document-scanner.module';

@NgModule({
    declarations: [
        GedResultComponent,
        GedDesignComponent,
        GedFormComponent, DynamicGedComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        MaterialModule,
        DocumentScannerModule
    ],
    entryComponents: [
        DynamicGedComponent
    ]
})
export class GedModule {}